import { MIN_LEN } from '@/constants';
import type { SixCatalogItem } from '@/types/Sixes';

export function getFileCountFromSix(six: SixCatalogItem): number {
  const fileCountValue = six.fileCount;
  if (typeof fileCountValue === 'number') return fileCountValue;
  return MIN_LEN;
}

export function toDate(value: Date | string | number): Date | null {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function getLastActivityLabel(lastModified: SixCatalogItem['lastModified']): string {
  const date = toDate(lastModified);
  if (date === null) return '';
  return date.toLocaleString();
}

export function getLastActivitySortValue(lastModified: SixCatalogItem['lastModified']): number {
  const date = toDate(lastModified);
  if (date === null) return 0;
  return date.getTime();
}
